import {useState} from "react";
import '../../assets/theme/cocos.css';

const CocosClient = () => {
    const [iframeSrc] = useState(`/cocos/client/${window.location.search}`);


    return (<div className='cocos-container'>
        <iframe src={iframeSrc}></iframe>
    </div>)
}

export default CocosClient;